import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, size } from "lodash";

import Grid from "@material-ui/core/Grid";

import TableContainer from "../Common/Table/TableContainer";
import EventDetails from "./EventDetails";
import EventsTopBar from "./EventsTopBar";
import EventGroupsTable from "./EventGroupsTable";

import { getLov } from "../../utils/lov";

const styles = {
  mainContainerTableDialog: {
    width: "100%",
    padding: 0,
  },
  mainContainerTable: {
    width: "100%",
    margin: "0 auto",
    paddingBottom: "5px",
  },
  mainContainerDetails: {
    paddingTop: "24px",
    paddingBottom: "5px",
  },
  mainContainerDetailsDialog: {
    padding: 0,
  },
};

const Events = (props) => {
  const {
    classes,
    events,
    total,
    isFetching,
    isFetchingChild,
    dialog = false,
    loadData,
    selectEvent,
    selectedEvent,
    loadChildEventGroups,
    closeDetailsPanel,
    goToEventGroup,
    section,
    selectedEventId,
    language,
    displayOptions,
    myprofile
  } = props;
  const [lov, setLov] = React.useState();

  React.useEffect(() => {
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchLov = async () => {
    try {
      setLov({
        riskLevel: await getLov("riskLevel"),
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Grid container direction="column">
      {!get(displayOptions, ["hideSectionBar"]) && !dialog && (
        <Grid item>
          <EventsTopBar section={section} />
        </Grid>
      )}
      <Grid item style={{ maxWidth: "calc(100%)" }}>
        <Grid container wrap="nowrap">
          <Grid
            item
            xs
            style={{
              maxWidth: selectedEvent ? "calc(100% - 550px)" : "",
              paddingRight: selectedEvent ? "24px" : "",
            }}
            className={
              dialog || get(displayOptions, ["noPadding"])
                ? classes.mainContainerTableDialog
                : `${classes.mainContainerTable} mainContainer`
            }
          >
            <TableContainer
              count={total}
              loadData={loadData}
              isFetching={isFetching}
              section={section}
              onlyOneItem={dialog}
              initialLoad={selectedEventId && size(events) > 0 ? false : true}
              height={get(displayOptions, ["tableHeight"])}
              noShadow={get(displayOptions, ["noShadow"])}
            >
              <EventGroupsTable
                data={events}
                language={language}
                lov={lov}
                onSelect={selectEvent}
                selectedEvent={get(selectedEvent, ["id"])}
                dialog={dialog}
                loadChildEventGroups={loadChildEventGroups}
                fetchingChild={isFetchingChild}
                myprofile={myprofile}
              />
            </TableContainer>
          </Grid>
          {selectedEvent && (
            <Grid
              item
              style={{ width: "550px" }}
              className={`${
                dialog || get(displayOptions, ["noPadding"])
                  ? classes.mainContainerDetailsDialog
                  : classes.mainContainerDetails
              }`}
            >
              <EventDetails
                data={selectedEvent}
                language={language}
                onClose={closeDetailsPanel}
                lov={lov}
                goToEventGroup={goToEventGroup}
                parentEventData={events.length>0? events[0]:{}}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(Events);
